const partnerIndustryLabelMap: Record<string, string> = {
  EDUCATION: "교육 / Education",
  AGRICULTURE: "농업 / Agriculture",
  AGRICULTURAL_PRODUCTS: "농산물 / Agricultural Products",
  PETS: "반려동물 / Pets",
  FITNESS: "피트니스 / Fitness",
  WELLNESS: "웰니스 / Wellness",
  BEAUTY: "뷰티 / Beauty",
  TRAVEL: "여행 / Travel",
  GOLF: "골프 / Golf",
  IT: "IT",
  DEVELOPMENT: "개발 / Development",
  AI: "AI",
  LLM: "LLM",
  DEEP_LEARNING: "딥러닝 / Deep Learning",
  IOT: "IoT",
  IMAGE_PROCESSING: "영상처리 / Image Processing",
  THREE_D: "3D",
  DEVICE: "디바이스 / Device",
  APP_TECH: "앱테크 / App Tech",
  STARTUP: "스타트업 / Startup",
  PLATFORM: "플랫폼 / Platform",
  COMMERCE: "커머스 / Commerce",
  AGENCY: "에이전시 / Agency",
  COMMUNITY: "커뮤니티 / Community",
  GLOBAL: "글로벌 / Global",
  B2B: "B2B",
  SAAS: "SaaS",
  PRODUCTIVITY: "업무생산성 / Productivity",
  CRM: "CRM",
  AUTOMATION: "자동화 / Automation",
  CONSULTING: "컨설팅 / Consulting",
  ADVERTISING: "광고 / Advertising",
  MARKETING: "마케팅 / Marketing",
  CONTENT: "콘텐츠 / Content",
  WEB_NOVEL: "웹소설 / Web Novel",
  K_POP: "K-pop",
  CHARACTER: "캐릭터 / Character",
  AVATAR: "아바타 / Avatar",
  VIRTUAL: "버추얼 / Virtual",
  PUBLIC_DATA: "공공데이터 / Public Data",
  CONSTRUCTION: "건설 / Construction",
  FOREIGNER: "외국인 / Foreigner",
  HR: "HR / Human Resources",
  MENTAL_CARE: "멘탈케어 / Mental Care",
  HEALTHCARE: "헬스케어 / Healthcare",
  OTHER: "기타 / Other"
};

export function partnerIndustryLabel(value: string | null | undefined) {
  if (!value) return "-";
  return partnerIndustryLabelMap[value] ?? value;
}
